// extracted by mini-css-extract-plugin
export default {"header":"header-wke1ts","title":"title-AWUaMF","flag":"flag-Peetlh","banner":"banner-JPCQt1"};